var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#fff",
    rx: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.829 9.829a.55.55 0 0 1-.404.171.55.55 0 0 1-.404-.171L7 7.809l-2.02 2.02a.55.55 0 0 1-.405.171.55.55 0 0 1-.404-.171A.55.55 0 0 1 4 9.425q0-.233.172-.404L6.192 7 4.172 4.98A.55.55 0 0 1 4 4.575q0-.231.172-.403A.55.55 0 0 1 4.576 4q.233 0 .404.172L7 6.192l2.02-2.02A.55.55 0 0 1 9.426 4q.233 0 .404.172.173.171.171.404 0 .233-.171.404L7.809 7l2.02 2.02a.55.55 0 0 1 .172.404q0 .232-.172.405"
  })));
};
export default SvgClose;